import { jsonMember, jsonObject } from 'typedjson';
import { PublicIssueType } from '../../enums/public-issue-type';
import { PublicIssueComplaintRequest } from './public-issue-complaint.request';
import { Nillable } from '@web/utils';

@jsonObject
export class PublicIssueCreateRequest {
  @jsonMember(String)
  public readonly type!: PublicIssueType;

  @jsonMember(String)
  public readonly dignity!: string;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly phone!: string;

  @jsonMember(String)
  public readonly message!: string;

  @jsonMember(Boolean)
  public readonly acceptRules!: boolean;

  @jsonMember(PublicIssueComplaintRequest)
  public readonly complaint?: Nillable<PublicIssueComplaintRequest>;

  public constructor(
    private readonly data: {
      type: PublicIssueType;
      dignity: string;
      email: string;
      phone: string;
      message: string;
      acceptRules: boolean;
      complaint?: Nillable<PublicIssueComplaintRequest>;
    },
  ) {
    this.type = this.data.type;
    this.dignity = this.data.dignity;
    this.email = this.data.email;
    this.phone = this.data.phone;
    this.message = this.data.message;
    this.acceptRules = this.data.acceptRules;
    this.complaint = this.data.complaint;
  }
}
